import { AuthUser, GradeKey } from '@gyym/sdk'
import { useGyymClient } from '@gyym/sdk-react'
import { useModal } from '@gyym/ui'
import React from 'react'

import { GyymPassModal } from '@/components/Modals/GyymPassModal'
import {
  pushModalCompleteQuestEvent,
  pushModalRankDownEvent,
  pushModalRankUpEvent,
  pushModalWelcomeBackEvent,
} from '@/lib/googleTagManager'
import { useAuthUser } from '@/modules/Auth'

import { GradeNotificationType } from '../constants'
import { useGradeNotification } from './useGradeNotification'

const pushEvent = (
  notificationType: GradeNotificationType,
  authUser: AuthUser,
  gradeKey: GradeKey,
) => {
  switch (notificationType) {
    case GradeNotificationType.GRADE_UP:
      pushModalRankUpEvent(authUser, gradeKey)
      break
    case GradeNotificationType.GRADE_DOWN:
      pushModalRankDownEvent(authUser, gradeKey)
      break
    case GradeNotificationType.ACHIEVEMENT:
      pushModalCompleteQuestEvent(authUser, gradeKey)
      break
    case GradeNotificationType.WELCOME_BACK:
      pushModalWelcomeBackEvent(authUser, gradeKey)
      break
    default:
      return
  }
}

/**
 * Check and open GYYM PASS modal if needed
 */
export const useGyymPassModalEffect = () => {
  const client = useGyymClient()
  const { authUser } = useAuthUser()
  const { openModal } = useModal()
  const { data: gradeNotification } = useGradeNotification()
  const [isMarkedAsRead, setMarkedAsRead] = React.useState(false)

  const onModalOpen = React.useCallback(async () => {
    if (!gradeNotification || !authUser) return

    const notificationType = gradeNotification.type
    const gradeKey = gradeNotification.afterGrade.key

    pushEvent(notificationType, authUser, gradeKey)

    try {
      await client.user.me.markGradeNotificationAsRead()
    } catch {
      // TODO: Handle error
    }

    setMarkedAsRead(true)
  }, [client, gradeNotification, authUser])

  React.useEffect(() => {
    if (!gradeNotification) return

    openModal(GyymPassModal, {
      grade: gradeNotification.afterGrade,
      type: gradeNotification.type,
      onOpen: onModalOpen,
      isButtonDisabled: !isMarkedAsRead,
      isAfterProfileUpdate: false,
    })
  }, [isMarkedAsRead, gradeNotification, openModal, onModalOpen])
}
